import React from "react";
import { Panel, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useGet } from "app/hooks";
import { Trans, formatThousand } from "app/utils";
import getUserName from "app/utils/getUserName";

type HostProps = {
  host: CHQ.EventHost;
};

const Host: React.FC<HostProps> = ({ host }) => (
  <li>
    <div className="profile_name">
      <img src={host.user.avatar.thumbUrl} alt={getUserName(host.user)} />
      <span>
        <h5>{getUserName(host.user)}</h5>
        <h5 className="text_secondary">{host.user.title}</h5>
      </span>
    </div>
    <h4>{formatThousand(host.hosted)}</h4>
  </li>
);

export type ListEventHosts = {
  hosts: CHQ.EventHost[];
};

const EventHostContent: React.FC = () => {
  const get = useGet<ListEventHosts>("/analytics/events/hosts");

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <div className="card_info">
      <ul className="profile_list">
        {get.got.hosts.map(host => (
          <Host key={host.user.id} host={host} />
        ))}
      </ul>
    </div>
  );
};

const EventHost: React.FC = () => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Top Culture Creators</Trans>
        </h3>
      </div>
      <EventHostContent />
    </Panel.Body>
  </Panel>
);

export default EventHost;
